import actions from './actions';
import mutations from './mutations';
import state from './state';
import getters from './getters';

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/tickets/index.ts